import {
  AfterViewInit,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Renderer2,
  Self,
  ViewContainerRef,
} from '@angular/core';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { MAT_FORM_FIELD, MatFormField } from '@angular/material/form-field';
// eslint-disable-next-line max-len
import { BorderErrorContainerDirective } from '@shared/components/most-used/form-error/border-error-container.directive';
import { EMPTY, merge, Observable, Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { FormErrorComponent } from './form-error-component/form-error.component';
import { customFormErrors, defaultFormErrors, ErrorDictionary } from './form-errors.list';
import { FormEventsDirective } from './form-events.directive';

interface IFormError {
  key: string;
  text: string;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector,max-len
  selector:
  // eslint-disable-next-line @angular-eslint/directive-selector
  //   '[formControlName]:not(.disable-form-error),[formControl]:not(.disable-form-error),[formControlErrors]',
    '[formControlErrorsOLD]',
})
export class FormErrorDirective implements OnInit, AfterViewInit, OnDestroy {
  /*
  * If you want the border coloring to work with mat-form-field,
  * for this you need to switch the class ".mat-form-field-invalid".
  * For other cases, you can use the "borderErrorContainer" directive, or not use and
  * the border will be colored at the input of the element.
  * */
  @Input('formControlErrorsLevel') errorLevel: 'off' | 'full' | 'onlyBorder';
  @Input('formControlErrorsFocus') showErrorIfFocused: boolean;
  ref: ComponentRef<FormErrorComponent>;
  container: ViewContainerRef;
  borderContainer: ViewContainerRef;
  formUpdate$: Observable<any>;
  updateControl$ = new Subject();
  blur$ = new Subject();
  focused: boolean;
  subs: Subscription[] = [];
  errors: ErrorDictionary;

  constructor(
    private renderer2: Renderer2,
    @Self() private control: NgControl,
    @Optional() private updateEvents: FormEventsDirective,
    @Optional() private controlErrorContainer: ControlErrorContainerDirective,
    @Optional() private borderErrorContainer: BorderErrorContainerDirective,
    private elRef: ElementRef,
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    @Optional() @Inject(MAT_FORM_FIELD) private _formField?: MatFormField,
  ) {
    this.errors = {
      ...defaultFormErrors,
      ...customFormErrors,
    };
    // console.log('FormControlDirective init', this.control, this.container);
  }

  @HostListener('blur')
  handleBlur() {
    this.blur$.next();
    this.focused = false;
  }

  @HostListener('focus')
  handleFocus() {
    this.focused = true;
  }

  ngOnInit() {
    console.log(this);
    console.log(this.elRef.nativeElement);
  }

  ngAfterViewInit() {
    this.formUpdate$ = this.updateEvents ? this.updateEvents.formEvents.asObservable() : EMPTY;
    setTimeout(() => {
      this.container = this.controlErrorContainer?.vcr || this.vcr;
      this.borderContainer = this.borderErrorContainer?.elRef.nativeElement || this.elRef.nativeElement;
      this.subs.push(this.getInteractionHandler().subscribe());
      this.patchControl();
    },0)
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe);
  }

  patchControl() {
    const _control = this.control.control as unknown as UntypedFormControl;
    const mark = _control.markAsTouched;
    _control.markAsTouched = () => {
      mark.call(_control);
      this.updateControl$.next();
    };
    const markAsUntouched = _control.markAsUntouched;
    _control.markAsUntouched = () => {
      markAsUntouched.call(_control);
      this.updateControl$.next();
    };
  }

  getInteractionHandler() {
    return merge(
      this.formUpdate$,
      this.updateControl$,
      this.blur$,
      this.control.valueChanges,
      this.control.statusChanges,
    ).pipe(
      tap((event) => {
        // console.log('FormErrorDirective got event', event, this.control);
        if (this.control.touched || [ 'submitted', 'VALID' ].includes(event)) {
          const error = this.getFormError();
          setTimeout(() => {
            this.setError(error);
          },0)
        }
      }),
    );
  }

  setError(error: IFormError) {
    if (this.errorLevel === 'off') {
      return;
    }

    if (!this.ref && this.errorLevel !== 'onlyBorder') {
      console.log('!!!!!!!!!!!!', this.errorLevel);
      const factory = this.resolver.resolveComponentFactory(FormErrorComponent);
      this.ref = this.container.createComponent(factory);
    }
    if (this.ref) {
      this.ref.instance.text = error?.text;
    }
    this.setBorderColor(!Boolean(error));
    this.toggleBorderByFocus();
  }

  getFormError(): IFormError {
    const controlErrors = this.control.errors;
    if (controlErrors) {
      const firstKey = Object.keys(controlErrors).slice(-1)[0];
      const getError = this.errors[firstKey] || this.errors['default'];
      const text = getError(controlErrors[firstKey]);
      return { key: firstKey, text };
    } else {
      return null;
    }
  }

  setBorderColor(cancel: boolean) {
    if (!cancel) {
      return this.renderer2.addClass(this.borderContainer, 'gl-border-error');
    }
    this.renderer2.removeClass(this.borderContainer, 'gl-border-error');
  }

  toggleBorderByFocus() {
    if (this.focused) {
      return this.renderer2.addClass(this.borderContainer, 'gl-border-focused');
    }
    this.renderer2.removeClass(this.borderContainer, 'gl-border-focused');
  }
}
